import './TicketAITimeline.scss';

import { Divider, Flex, Timeline, TimelineItemProps } from 'antd';
import { useMemo } from 'react';

import { Ticket } from '@/model/Ticket/Ticket';

interface TicketAITimelineProps {
  record: Ticket;
}

const TicketAITimeline = (props: TicketAITimelineProps) => {
  const { record } = props;
  const { ia_timeline } = record;
  const timelineData: TimelineItemProps[] = useMemo(() => {
    if (!ia_timeline || ia_timeline.length === 0) {
      return [];
    }

    const timelineData: TimelineItemProps[] = ia_timeline.map(item => ({
      // Estructuramos el contenido en capas para poder darle mas jerarquia visual desde SCSS.
      children: (
        <div className="TicketAITimelineItem">
          <Flex gap={8} align="center" className="TicketAITimelineItemHeader">
            <span className="TicketAITimelineItemDate">{item.fecha ?? 'No definido'}</span>
            <Divider type="vertical" />
            <span className="TicketAITimelineItemType">{item.tipo ?? 'No definido'}</span>
          </Flex>
          <h4 className="TicketAITimelineItemTitle">{item.titulo ?? 'No definido'}</h4>
          <p className="TicketAITimelineItemDescription">{item.descripcion_reducida ?? '-'}</p>
        </div>
      ),
    }));

    return timelineData;
  }, [ia_timeline]);

  return <Timeline className="TicketAITimeline" items={timelineData} />;
};

export default TicketAITimeline;
